import { createModel } from "hox";
import { useState, useEffect } from "react";
import { EnquiryStatisticsItem, EnquiryStatisticsQuery } from "./enquiryType";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { transPgToPagination } from "@/utils/utils";
import { ISearchPage } from "@/types/ScmTypes";
import { enquiryService } from "./enquiryService";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
export interface IDescTotal {
    num: number
    totalAmount: number
    receivableTotalAmount: number
}
export interface IPrint {
    visible: boolean,
    type: number,
}
export const useEnquiryModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const [print, setPrint] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)
    const initDesc = {
        num: 0,
        totalAmount: 0,
        receivableTotalAmount: 0
    }
    const initSearchParam: EnquiryStatisticsQuery = {};
    const initDataSource: EnquiryStatisticsItem[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<EnquiryStatisticsQuery>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<EnquiryStatisticsItem[]>(initDataSource);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    //const [selectedRow, setSelectedRow] = useState<EnquiryStatisticsItem>({});
    const [descRows, setDescRows] = useState<EnquiryStatisticsItem[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    useEffect(() => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
    }, [shopAndOrg.shopCode])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        //setSelectedRow(selectedData as EnquiryStatisticsItem)
    }, [selectedRowKeys, dataSource])

    const updateSearchParam = (updateParam: EnquiryStatisticsQuery) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: EnquiryStatisticsQuery = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await enquiryService.enquiryStatic(searchParams);
        setLoading(false);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));

        // 处理 records，添加是否到期的状态
        let data = records.map((item: any) => {
            const now = new Date();
            const endTime = new Date(item.endTime);
            const isExpired = now >= endTime;

            return {
                ...item,
                isExpired: item.endTime ? isExpired : false,  // 添加是否过期的标志
            };
        });

        setDataSource(data); // 假设你最终要使用 setDataSource
    }

    const exportData = async (searchValue: EnquiryStatisticsQuery = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            id: selectedRowKeys.join(),
        }
        try {
            let result = await enquiryService.enquiryStaticExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }

    return {
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        initPgCfg,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        print, setPrint,
        exportData,
        loading, setLoading,
        descRows, setDescRows,
        reset,
    }
})